import React from 'react';
import PropTypes from 'prop-types';
// import styles from './AnimatedArrows.module.less';
// import useAnimatedArrows from './useAnimatedArrows';
import './AnimatedArrows.css';

function AnimatedArrows({ directions }) {

  return (
    <>
      {/* directions: directionLeft || directionTop || directionRight || directionBottom */}
      {/* directionTopDeactivate || directionLeftDeactivate
      || directionBottomDeactivate || directionRightDeactivate */}
      <div className={`animArrow ${directions}`}>
        <div id="arrowAnim">
          <div className="arrowSliding">
            <div className="arrow" />
          </div>
          <div className="arrowSliding delay1">
            <div className="arrow" />
          </div>
          <div className="arrowSliding delay2">
            <div className="arrow" />
          </div>
          <div className="arrowSliding delay3">
            <div className="arrow" />
          </div>
        </div>
      </div>
    </>
  );

}

AnimatedArrows.propTypes = {

  directions: PropTypes.string.isRequired,
  // deactive: PropTypes.bool.isRequired,

};

export default (AnimatedArrows);
